import styled from 'styled-components';

import MapIcon from '@mui/icons-material/Map';
import SatelliteIcon from '@mui/icons-material/Satellite';

import { CommonPropsButtons } from '../styles';

export const StyledMapIcon = styled(MapIcon)`
  ${CommonPropsButtons}
`;

export const StyledPressedMapIcon = styled(StyledMapIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const StyledSatelliteIcon = styled(SatelliteIcon)`
  ${CommonPropsButtons}
`;

export const StyledPressedSatelliteIcon = styled(StyledSatelliteIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
`;
